import * as React from 'react';
import { flatCard, IMG_WIDTH, imgContainer } from './FlatCard.styles';
import StarRatings from 'react-star-ratings';
import CenteredImage from 'src/components/CenteredImage/CenteredImage';
import { Tooltip } from '@material-ui/core';
import { CompanionFieldClasses } from '../CompanionListView';
import { decorateTextByClasses } from 'src/utils/Domain/Renderer';
export interface FlatCardProps {
  index: number;
  className?: string;
  id: string;
  title?: string;
  name: string;
  stars: null | number;
  imageUri?: string;
  noImageUrl?: string;
  hoverElement?: JSX.Element;
  cardHeight: number;
  fieldClasses?: CompanionFieldClasses;
  onClick?(id: string, event?: React.MouseEvent<HTMLDivElement, MouseEvent>): void;
}

export default function FlatCard(props: FlatCardProps) {
  const className = props.className ? flatCard + ' ' + props.className : flatCard;
  const titleText = props.title || props.id;
  // Apply any field classes to title and name
  const titleNode = decorateTextByClasses(titleText, props.fieldClasses?.title ?? []);
  const nameNode = decorateTextByClasses(props.name, props.fieldClasses?.name ?? []);

  return (
    <div
      className={className + ' flat-card'}
      key={props.index}
      onClick={(evt) => {
        props.onClick ? props.onClick(props.id, evt) : undefined;
      }}
    >
      {props.hoverElement && <div className="hoverElement">{props.hoverElement}</div>}
      <span className="left-pane">
        <span className="id">{titleNode}</span>

        <Tooltip title={props.name ?? ''} disableHoverListener={!(props.name?.length > 30)}>
          <span className="name">{nameNode}</span>
        </Tooltip>
        {props.stars !== null ? (
          <StarRatings
            rating={props.stars || 0}
            className="stars"
            numberOfStars={5}
            starDimension={'1rem'}
            starSpacing={'0.1rem'}
            starRatedColor={'#ff8802'}
          />
        ) : null}
      </span>
      {(props.imageUri || props.noImageUrl) && (
        <CenteredImage
          src={props.imageUri || props.noImageUrl}
          width={IMG_WIDTH}
          height={props.cardHeight}
          extraContainerClass={imgContainer}
        />
      )}
    </div>
  );
}
